import React from 'react';

export default (props) => {

    return (
        <div className="spacer" style={{height: props.height}} />
    );

}


// WEBPACK FOOTER //
// ./src/js/components/Spacer.js